module.exports = __webpack_public_path__ + "static/media/blocker_challenge.3af8e1ab.png";